<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Справочники</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <ul>
      <li>
        <a href="/citizenships">Справочник гражданства</a>
      </li>
      <li>
        <a href="/degrees">Справочник категорий</a>
      </li>
      <li>
        <a href="/regions">Справочник областей</a>
      </li>
      <li>
        <a href="/universities">Справочник университетов</a>
      </li>
      <li>
        <a href="/professions">Справочник специальностей</a>
      </li>
      <li>
        <a href="/professions-cost">Справочник стоимости кредитов по годам</a>
      </li>
      <li>
        <a href="/professions-foreign-amounts">Справочник суммы по филиалам зарубежных вузов</a>
      </li>

      <li>
        <a href="/dict/edu-areas">Справочник область образование</a>
      </li>
      <li>
        <a href="/dict/profession-directions">Справочник направление специальностей</a>
      </li>

    </ul>
  </div>
  <div class="page-footer">
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "DictionariesView"
});
</script>

<style scoped>
</style>
